import React, { useEffect } from "react";
import { useI18n, t } from "@bookingcom/lingojs-react";
import { useStore, useActions } from "../../../store/index.js";
import { actions as OrderActions } from "../../../store/order/actions.js";
import { actions as RebookPolicyActions } from "../../../store/rebookPolicy/actions.js";
import { useClientFetch } from "../../../hooks/useClientFetch.js";
import ErrorAlert from "../ErrorAlert/index.js";
import NotAvailableIllustration from "../../../assets/illustrations/not-available.svg";
import { useLocation } from "react-router-dom";
import styles from "./ConfirmationInnerLoader.module.css";
import flights_ace_web_post_booking_et_goals_aa, { useTrackPostBookingETGoals } from "../../../utils/experiments/ace/flights_ace_web_post_booking_et_goals_aa.js";
import useContextName from "../../../hooks/useContextName.js";
const ConfirmationInnerLoader = (props) => {
    const i18n = useI18n();
    const contextName = useContextName();
    const { children, loadingSkeleton, loadingCopyTag = i18n.trans(t("flights_select_in_progress")), cache = false, fetchAsyncRebookPolicy = false, cancellationOptionsType = 0 } = props;
    const orderActions = useActions(OrderActions);
    const rebookPolicyActions = useActions(RebookPolicyActions);
    const store = useStore();
    const query = new URLSearchParams(useLocation().search);
    const searchParams = new URLSearchParams();
    searchParams.set("pb", "1");
    if (props.includeAvailableExtras) {
        searchParams.append("includeAvailableExtras", "1");
    }
    if (cancellationOptionsType) {
        searchParams.append("cancellationOptionsType", cancellationOptionsType.toString());
    }
    const addOnOrderId = query.get("addOnOrderId");
    if (addOnOrderId) {
        searchParams.append("addOnOrderId", addOnOrderId);
    }
    const fetchFromCache = cache && !query.get("confirm_cancel") && !query.get("refresh");
    useClientFetch(`/api/order/${props.token}?${searchParams.toString()}`, {
        shouldGenerateNewClientsidePayload: true,
        condition: () => {
            if (!!query.get("confirm_cancel") || !!query.get("refresh")) {
                return true;
            }
            else if (cache && store.order.fetchStatus === "success") {
                return false;
            }
            else {
                return true;
            }
        },
        fetch: orderActions.fetch,
        error: orderActions.fetchError,
        success: orderActions.fetchSuccess,
        cache: fetchFromCache
    });
    useClientFetch(`/api/order/${props.token}/rebookPolicy`, {
        condition: () => fetchAsyncRebookPolicy,
        fetch: rebookPolicyActions.fetch,
        error: rebookPolicyActions.fetchError,
        success: rebookPolicyActions.fetchSuccess
    });
    useTrackPostBookingETGoals(contextName);
    useEffect(() => {
        if (contextName === "pb_order_details") {
            flights_ace_web_post_booking_et_goals_aa.goals.order_details_page_loaded();
            if (store.order.fetchStatus === "failed") {
                flights_ace_web_post_booking_et_goals_aa.goals.order_details_page_loading_error();
            }
        }
        else if (contextName === "confirmation") {
            flights_ace_web_post_booking_et_goals_aa.goals.confirmation_page_loaded();
        }
    }, [store.order.fetchStatus, contextName]);
    if (store.order.fetchStatus === "failed") {
        return (React.createElement("div", null,
            React.createElement(ErrorAlert, { illustration: React.createElement(NotAvailableIllustration, null), title: i18n.trans(t("flights_error_timeout_header")), body: i18n.trans(t("flights_error_timeout_subheader")), buttonLabel: i18n.trans(t("flights_refresh_action")), onClick: () => window.location.reload() })));
    }
    return (React.createElement(React.Fragment, null, store.order.fetchStatus === "success" ? (React.createElement(React.Fragment, null, children)) : loadingSkeleton ? (React.createElement(React.Fragment, null, loadingSkeleton)) : (React.createElement("div", { className: styles.loading }, loadingCopyTag))));
};
export default ConfirmationInnerLoader;
